import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

function NotificationBell({ user }) {
  const token = localStorage.getItem("authToken");
  const [count, setCount] = useState(0);
  const audioRef = useRef(null);
  const location = useLocation();

  // Load unread notification count
  const loadNotificationCount = async () => {
    try {
      if (!token) return;

      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE}/host/get-notifications`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setCount(res.data?.count || 0);
    } catch (err) {
      console.error("Failed to load notification count:", err);
    }
  };

  // Load on component mount
  useEffect(() => {
    loadNotificationCount();
  }, [location.pathname]);

  // Setup alert sound
  useEffect(() => {
    audioRef.current = new Audio("/sounds/mixkit-bell-notification-933.wav");

    const unlockAudio = () => {
      audioRef.current
        .play()
        .then(() => {
          audioRef.current.pause();
          audioRef.current.currentTime = 0;
          window.removeEventListener("click", unlockAudio);
        })
        .catch(() => {});
    };

    window.addEventListener("click", unlockAudio);
    return () => window.removeEventListener("click", unlockAudio);
  }, []);

  // Listen for real-time notifications
  useEffect(() => {
    if (!user?.host_id) return;

    const channel = window.Echo.channel(`host-notifications.${user.host_id}`);

     channel.listen(".new-booking", (event) => {
      // console.log("📦 Event Payload:", event);

      audioRef.current
        ?.play()
        .catch((err) => console.warn("🔇 Audio blocked:", err));

      setCount(event.payload.notification_count || 0);
      
    });
  }, [user]);

  return (
    // <li
    //   className="bell-wrapper"
    //   onClick={() => navigate("/account-notification")}
    //   style={{ cursor: "pointer" }}
    // >
    <>
      <img src="/images/bell_icons.png" alt="Notification" />
      {count > 0 && (
        <span className="usr_count bell_count">{count > 9 ? "9+" : count}</span>
      )}
    </>
    // </li>
  );
}

export default NotificationBell;
